import { useSelector } from 'react-redux';
import { useMutation } from '@tanstack/react-query';
import { RootState } from 'state/store';

import { patchResponseForId } from 'services';

export interface SaveResponseProps {
  currentPageId: string;
  applicationId: string;
  propertyId: number;
  responses: { [key: string]: any }[];
  errorCount?: number;
  targetPageId?: string;
}

interface SaveResponse {
  responseData: SaveResponseProps;
  responseId: string;
  awaitSync?: boolean;
}

export function useSaveResponse() {
  const { mutateAsync: updateResponse } = useMutation({
    mutationFn: patchResponseForId,
  });

  const { responseId } = useSelector((state: RootState) => state.application.activeResponse);

  async function saveResponse(data: SaveResponseProps, resId?: string, awaitSync?: boolean) {
    const props: SaveResponse = {
      responseData: data,
      responseId: resId ?? responseId,
      awaitSync,
    };
    const response = await updateResponse(props);
    return response;
  }

  return saveResponse;
}
